/**
 * /en/admin/structure/types/manage/search_results_page/fields
 */
import Element from "../core/element.es6.js";
import Field from "../core/field.es6.js";
import LinkField from "../core/link-field.es6.js";

export default class SearchResultsPageContentType extends Element {
  get allResultsFilterLabel() {
    return new Field({
      machineName: 'field_all_results_filter_label',
      parentElement: this,
    });
  }

  get applyFilterLabel() {
    return new Field({
      machineName: 'field_apply_filter_label',
      parentElement: this,
    });
  }

  get clearLabel() {
    return new Field({
      machineName: 'field_clear_label',
      parentElement: this,
    });
  }

  get conditionFilterLabel() {
    return new Field({
      machineName: 'field_condition_filter_label',
      parentElement: this,
    });
  }

  get filterByCategoryLabel() {
    return new Field({
      machineName: 'field_filter_by_category_label',
      parentElement: this,
    });
  }

  get findLabel() {
    return new Field({
      machineName: 'field_find_label',
      parentElement: this,
    });
  }

  get forLabel() {
    return new Field({
      machineName: 'field_for_label',
      parentElement: this,
    });
  }

  get leadershipFilterLabel() {
    return new Field({
      machineName: 'field_leadership_filter_label',
      parentElement: this,
    });
  }

  get locationFilterLabel() {
    return new Field({
      machineName: 'field_location_filter_label',
      parentElement: this,
    });
  }

  get locationsResultsLabel() {
    return new Field({
      machineName: 'field_locations_results_label',
      parentElement: this,
    });
  }

  get noResultsText() {
    return new Field({
      machineName: 'field_no_results_text',
      parentElement: this,
    });
  }

  get ofLabel() {
    return new Field({
      machineName: 'field_of_label',
      parentElement: this,
    });
  }

  get pageLabel() {
    return new Field({
      machineName: 'field_page_label',
      parentElement: this,
    });
  }

  get providerFilterLabel() {
    return new Field({
      machineName: 'field_provider_filter_label',
      parentElement: this,
    });
  }

  get providersResultsLabel() {
    return new Field({
      machineName: 'field_providers_results_label',
      parentElement: this,
    });
  }

  get researchFilterLabel() {
    return new Field({
      machineName: 'field_research_filter_label',
      parentElement: this,
    });
  }

  get resultsLabel() {
    return new Field({
      machineName: 'field_results_label',
      parentElement: this,
    });
  }

  get searchButtonText() {
    return new Field({
      machineName: 'field_search_button_text',
      parentElement: this,
    });
  }

  get searchPlaceholder() {
    return new Field({
      machineName: 'field_search_placeholder',
      parentElement: this,
    });
  }

  get serviceFilterLabel() {
    return new Field({
      machineName: 'field_service_filter_label',
      parentElement: this,
    });
  }

  get servicesAndConditionsLabel() {
    return new Field({
      machineName: 'field_services_conditions_label',
      parentElement: this,
    });
  }

  get specialtyFilterLabel() {
    return new Field({
      machineName: 'field_specialty_filter_label',
      parentElement: this,
    });
  }

  get blogFilterLabel() {
    return new Field({
      machineName: 'field_blog_filter_label',
      parentElement: this,
    });
  }

  get blogCategoryFilterLabel() {
    return new Field({
      machineName: 'field_blog_category_filter_label',
      parentElement: this,
    });
  }

  get treatmentFilterLabel() {
    return new Field({
      machineName: 'field_treatments_filter_label',
      parentElement: this,
    });
  }

  get tryOurToolsBoldText() {
    return new Field({
      machineName: 'field_try_our_tools_bold_text',
      parentElement: this,
    });
  }

  get tryOurToolsEndingText() {
    return new Field({
      machineName: 'field_try_our_tools_end_text',
      parentElement: this,
    });
  }

  get tryOurToolsStartingText() {
    return new Field({
      machineName: 'field_try_our_tools_start_text',
      parentElement: this,
    });
  }

  get viewAllLocationsLink() {
    return new LinkField({
      machineName: 'field_view_all_locations_link',
      parentElement: this,
    });
  }

  get viewAllProvidersLink() {
    return new LinkField({
      machineName: 'field_view_all_providers_link',
      parentElement: this,
    });
  }

  get viewAllServicesAndConditionsLink() {
    return new LinkField({
      machineName: 'field_view_all_serv_cond_link',
      parentElement: this,
    });
  }

  get viewLabel() {
    return new Field({
      machineName: 'field_view_label',
      parentElement: this,
    });
  }

  constructor() {
    super({ selector: '.search-results-page--wrapper' });
  }
}
